import React from "react";
import { CheckCircle, Clock, Shield, BarChart3, Users, Zap, DollarSign, FileText, Smartphone, Globe } from "lucide-react";

const SmartWorkTrackerServices: React.FC = () => {
    return (
        <div className="space-y-8">
            {/* Header Section */}
            <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    Smart Work Tracker Services
                </h2>
                <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                    Comprehensive time tracking and productivity monitoring solutions designed to bring transparency,
                    efficiency, and trust to your freelance projects.
                </p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <div className="text-center mb-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                        Track your freelancer&apos;s actual hours with precision, transparency, and simplicity.
                    </h3>
                    <p className="text-sm text-gray-600 mb-1">
                        With Smart Work Tracker, you always know how many hours are actually spent on each project.
                    </p>
                    <p className="text-sm text-gray-600">
                        Thanks to an intelligent tracking system, clients have maximum transparency and freelancers can work worry-free.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Benefits for Customer */}
                    <div>
                        <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                            <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
                            Benefits for Customer
                        </h4>
                        <ul className="space-y-2">
                            <li className="flex items-start gap-2 text-sm text-gray-700">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Full transparency on freelancer&apos;s time and activities</span>
                            </li>
                            <li className="flex items-start gap-2 text-sm text-gray-700">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Clear, automated reports for payments and invoicing</span>
                            </li>
                            <li className="flex items-start gap-2 text-sm text-gray-700">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Greater trust and control over each project</span>
                            </li>
                        </ul>
                    </div>

                    {/* Benefits for Freelancers */}
                    <div>
                        <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                            <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
                            Benefits for Freelancers
                        </h4>
                        <ul className="space-y-2">
                            <li className="flex items-start gap-2 text-sm text-gray-700">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>No manual calculations → everything tracked automatically</span>
                            </li>
                            <li className="flex items-start gap-2 text-sm text-gray-700">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Faster payments with no disputes</span>
                            </li>
                            <li className="flex items-start gap-2 text-sm text-gray-700">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Increased credibility and client trust</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SmartWorkTrackerServices;
